import { Layout } from "../UI/Layout/Layout.tsx";
import { ScreenTitleBlock } from "../UI/Layout/ScreenTitleBlock.tsx";
import { Card } from "../UI/Card.tsx";
import {
  ProgressCheckPdfForm,
  ProgressCheckPdfFormInputs,
} from "./ProgressCheckPdfForm.tsx";
import { useCreateProgressCheckPdf } from "./useCreateProgressCheckPdf.ts";
import { useNavigate } from "react-router-dom";
import { ApolloError } from "@apollo/client";
import { useMessagePopupController } from "../UI/MessagePopup/useMessagePopupController.ts";
import { ErrorMessagePopup } from "../UI/MessagePopup/ErrorMessagePopup.tsx";
import { BreadCrumbsWrapper } from "../UI/Layout/BreadCrumbsWrapper.tsx";
import { BreadCrumbsItem } from "../UI/Layout/BreadCrumbsItem.tsx";
import { CoursePdfsScreenPath } from "../CoursePdf/paths.ts";
import { useToCoursePdfs } from "../CoursePdf/useToCoursePdfs.ts";

export function CreateProgressCheckPdfScreen() {
  const { create } = useCreateProgressCheckPdf();
  const navigate = useNavigate();
  const { toCoursePdfs } = useToCoursePdfs();
  const { show, title, description, showPopup } = useMessagePopupController(
    4 * 1000,
  );

  async function onSave(input: ProgressCheckPdfFormInputs) {
    try {
      await create({
        level: input.level,
        pdfUrl: input.pdfUrl,
        userGroupId: input.userGroupId,
      });
    } catch (e) {
      const error = e as ApolloError;
      showPopup("Error", error?.message ?? "Unknown error");
      return;
    }

    navigate(CoursePdfsScreenPath);
  }

  return (
    <>
      <ErrorMessagePopup title={title} description={description} show={show} />
      <Layout>
        <Card>
          <ScreenTitleBlock
            title={"New Progress Check PDF"}
            breadCrumbs={
              <BreadCrumbsWrapper>
                <BreadCrumbsItem title={"Course PDFs"} onClick={toCoursePdfs} />
                <BreadCrumbsItem title={"New"} />
              </BreadCrumbsWrapper>
            }
          />
        </Card>
        <div className={"mt-4"}>
          <Card>
            <ProgressCheckPdfForm onSave={onSave} />
          </Card>
        </div>
      </Layout>
    </>
  );
}
